import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import PaginationLink from './PaginationLink';
import ClientProvider from './client';
export default createDemo(import.meta.url, PaginationLink, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/pagination/demos/link/PaginationLink.tsx",
    "fileName": "PaginationLink.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { Link, MemoryRouter, Route, Routes, useLocation } from 'react-router';\nimport Pagination from '@mui/material/Pagination';\nimport PaginationItem from '@mui/material/PaginationItem';\n\nfunction Content() {\n  const location = useLocation();\n  const query = new URLSearchParams(location.search);\n  const page = parseInt(query.get('page') || '1', 10);\n  return (\n    <Pagination\n      page={page}\n      count={10}\n      renderItem={(item) => (\n        <PaginationItem\n          component={Link}\n          to={`/inbox${item.page === 1 ? '' : `?page=${item.page}`}`}\n          {...item}\n        />\n      )}\n    />\n  );\n}\n\nexport default function PaginationLink() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <MemoryRouter initialEntries={['/inbox']} initialIndex={0}>\n      <Routes>\n        <Route path=\"*\" element={<Content />} />\n      </Routes>\n    </MemoryRouter>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 32,
        "focusedLines": 5,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { Link, MemoryRouter, Route, Routes, useLocation } from 'react-router';\nimport Pagination from '@mui/material/Pagination';\nimport PaginationItem from '@mui/material/PaginationItem';\n\nfunction Content() {\n  const location = useLocation();\n  const query = new URLSearchParams(location.search);\n  const page = parseInt(query.get('page') || '1', 10);\n  return (\n    <Pagination\n      page={page}\n      count={10}\n      renderItem={(item) => (\n        <PaginationItem\n          component={Link}\n          to={`/inbox${item.page === 1 ? '' : `?page=${item.page}`}`}\n          {...item}\n        />\n      )}\n    />\n  );\n}\n\nexport default function PaginationLink() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <MemoryRouter initialEntries={['/inbox']} initialIndex={0}>\n      <Routes>\n        <Route path=\"*\" element={<Content />} />\n      </Routes>\n    </MemoryRouter>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 26
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "MemoryRouter"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "initialEntries"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "[",
              [
                "span",
                "pl-s",
                [
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ],
                  "/inbox",
                  [
                    "span",
                    "pl-pds",
                    "'"
                  ]
                ]
              ],
              "]",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "initialIndex"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "0"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 27
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Routes"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 28
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "Route"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "path"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "*",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "element"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "<",
              [
                "span",
                "pl-c1 di-jsx",
                "Content"
              ],
              " />",
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 29
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Routes"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 30
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "MemoryRouter"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 32,
    "focusedLines": 5,
    "collapsible": true,
    "externals": [
      "react-router",
      "@mui/material/Pagination",
      "@mui/material/PaginationItem"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
